import { lazy } from "react";

const Dashboard = lazy(() => import("../../pages/Dashboard"));
const Users = lazy(() => import("../../pages/Users"));
const Courses = lazy(() => import("../../pages/Courses"));
const CourseView = lazy(() => import("../../pages/Courses/View"));
const AddCourse = lazy(() => import("../../components/Course/AddCourse"));
const MCQ = lazy(() => import("../../pages/MCQ"));
const MCQView = lazy(() => import("../../pages/MCQ/View"));
const Settings = lazy(() => import("../../pages/Settings"));
const Uploads = lazy(() => import("../../pages/Uploads"));
const Survey = lazy(() => import("../../pages/Survey"));

export interface Route {
  name: string;
  path: string;
  component: any;
  protected: boolean;
}

export const protectedRoute: Route[] = [
  {
    name: "Dashboard",
    path: "/",
    component: Dashboard,
    protected: true,
  },
  {
    name: "Users",
    path: "/users",
    component: Users,
    protected: true,
  },
    {
    name: "Uploads",
    path: "/uploads",
    component: Uploads,
    protected: true,
  },
  {
    name: "Courses",
    path: "/courses",
    component: Courses,
    protected: true,
  },
  {
    name: "Survey",
    path: "/survey",
    component: Survey,
    protected: true,
  },
  {
    name: "CoursesView",
    path: "/courses/:id",
    component: CourseView,
    protected: true,
  },
  {
    name: "AddCourse",
    path: "/courses/create",
    component: AddCourse,
    protected: true,
  },
  {
    name: "MCQ",
    path: "/mcq",
    component: MCQ,
    protected: true,
  },
  {
    name: "MCQView",
    path: "/mcq/:id",
    component: MCQView,
    protected: true,
  },
  {
    name: "Settings",
    path: "/settings",
    component: Settings,
    protected: true,
  },
];
